<template>
  <div class="date-range-filter-container">
    <div class="date-range-filter-row">
      <div class="date-range-field">
        <label>{{ $t("common.date_from") }}</label>
        <DxDateBox
          :value="dateFrom"
          type="date"
          :display-format="getDxGridDefaultDateFormat"
          :showClearButton="true"
          :openOnFieldClick="true"
          :placeholder="$t('common.select_date')"
          @valueChanged="onDateFromChange"
        />
      </div>
      <div class="date-range-separator">-</div>
      <div class="date-range-field">
        <label>{{ $t("common.date_to") }}</label>
        <DxDateBox
          :value="dateTo"
          type="date"
          :display-format="getDxGridDefaultDateFormat"
          :showClearButton="true"
          :openOnFieldClick="true"
          :placeholder="$t('common.select_date')"
          @valueChanged="onDateToChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DxDateBox from "devextreme-vue/date-box";
import { mapGetters } from "vuex";

export default {
  name: "DateRangeFilter",
  components: {
    DxDateBox,
  },
  props: {
    dateFrom: {
      type: [Date, String, null],
      default: null,
    },
    dateTo: {
      type: [Date, String, null],
      default: null,
    },
  },
  computed: {
     ...mapGetters({
      getDxGridDefaultDateFormat: "settings/getDxGridDefaultDateFormat",
    }),
  },
  methods: {
    onDateFromChange(value) {
      this.$emit("update:dateFrom", value.value);
    },
    onDateToChange(value) {
      this.$emit("update:dateTo", value.value);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/global/colors.scss";

.date-range-filter-container {
  margin: 0;
}

.date-range-filter-row {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}

.date-range-field {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.date-range-field label {
  font-size: 14px;
  color: $gray-70;
  font-weight: 600;
  margin-bottom: 6px;
  display: block;
}

.date-range-separator {
  padding-bottom: 8px;
  font-size: 16px;
  color: #999;
  user-select: none;
}

::v-deep .dx-dropdowneditor-icon {
  color: $brand-dark !important;
}

::v-deep .dx-dropdowneditor-icon::before {
  color: $brand-dark !important;
}
</style>
